import { useTranslation } from 'next-i18next'
import SocialMediaIcons from '../Footer/SocialMediaIcons'

function BlogSocial() {
  const { t } = useTranslation('blog')

  return (
    <section className="border-t border-ink-100/15 pt-12 md:pt-16">
      <div className="md:grid md:grid-cols-12 md:gap-12">
        <div className="md:col-span-5">
          <p className="font-display text-[11px] tracking-[0.22em] text-blue-500 uppercase md:text-xs">
            {t('SOCIAL.EYEBROW')}
          </p>
          <h3 className="mt-3 font-display text-[24px] leading-[1.15] font-medium text-ink-700 md:text-[32px]">
            {t('SOCIAL.TITLE')}
          </h3>
        </div>
        <div className="mt-5 flex flex-col gap-6 md:col-span-7 md:mt-0 md:items-end md:self-end">
          <p className="max-w-md text-[14px] leading-relaxed text-ink-200 md:text-right md:text-[15px]">
            {t('SOCIAL.DESC')}
          </p>
          <SocialMediaIcons
            primaryColor="text-ink-700"
            justifyContent="start"
          />
        </div>
      </div>
    </section>
  )
}

export default BlogSocial
